"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../Constants");
const rxjs_1 = require("rxjs");
const dialog_1 = require("@angular/material/dialog");
const plugins_1 = require("./plugins");
class EditorHandler extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.debug = Constants_1.Constants.debug_off;
    }
    open(who, text = null) {
        const tmp = new rxjs_1.Observable(subscriber => {
            this.openEditorObservable('Editor ' + who, text).subscribe(result => {
                subscriber.next(result);
                subscriber.complete();
            });
        });
        return tmp;
    }
    openEditorObservable(title, text) {
        let dialogRef = this.services.dialog.open(EditorDialog, {
            width: '60%',
            height: '860',
            data: { title: title, text: text }
        });
        return dialogRef.afterClosed();
    }
}
// required name identifier
EditorHandler.meta = {
    label: 'PLUGINS.EDITOR_HANDLER.LABEL',
    name: 'editor-handler',
    tooltip: 'PLUGINS.EDITOR_HANDLER.TOOLTIP',
    translator: 'PLUGINS.EDITOR_HANDLER',
    category: plugins_1.FdmPlugin.category.internal,
};
exports.EditorHandler = EditorHandler;
class EditorDialog {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.loading = false;
    }
    onCancelClick() {
        this.dialogRef.close(false);
    }
    onSaveClick() {
        let el = document.getElementById('texteditor');
        if (el) {
            this.data.text = el.value;
        }
        this.dialogRef.close(this.data);
    }
}
exports.EditorDialog = EditorDialog;
